import { getEnvironment } from '@minecraft.environment';
import Hotjar from '@hotjar/browser';
import { PRODUCTION, TEST, DEV } from '../Auth/constants';
import { UX_TRACKING_EVENT_NAMES } from './UxTrackingEventNames';

const isUxTrackingReady = () => Hotjar.isReady();
/**
 * Send a custom event for UX tracking
 * @param eventName - The name of the event to send
 */
export const sendUxTrackEvent = (eventName: UX_TRACKING_EVENT_NAMES) => {
  const environment = getEnvironment();
  if ([PRODUCTION, TEST, DEV].includes(environment.ENV) || process.env.TEST) {
    try {
      if (!isUxTrackingReady()) {
        console.warn('Hotjar is not ready for tracking events');
        return;
      }
      Hotjar.event(eventName);
    } catch (e) {
      console.error('Error sending Hotjar event:', e);
    }
  }
};

export const initUxTracking = (debug = false) => {
  const environment = getEnvironment();
  const siteId = environment.HOTJAR_SITE_ID;
  const hotjarVersion = 6;
  return Hotjar.init(Number(siteId), hotjarVersion, { debug });
};

/**
 * Identify a user in Hotjar
 * @param userId - The user ID to identify
 * @param userInfo - Additional user information
 */
export const identifyUserForUxTracking = (userId: string | null, userInfo: Record<string, any>) => {
  if (isUxTrackingReady()) {
    try {
      Hotjar.identify(userId, userInfo);
    } catch (e) {
      console.error('Error identifying user in Hotjar:', e);
    }
  } else {
    console.warn('Hotjar is not ready for user identification');
  }
};
